<template>
  <v-sheet class="pb-4 px-5 text-center transparent" max-width="600">
    <img class="mt-6 mb-3" :src="require('@/assets/appLogo-color--Onlight.svg')" width="24"/>
    <span class="d-block body-2 grey-700--text">Estás recibiendo este email porque eres cliente de {{account.name}}, quien utiliza Factura X para sus procesos de emisión.</span>
  </v-sheet>
</template>
<script>
import GenericViewMixin from '@/mixins/GenericViewMixin'
export default {
  mixins: [
    GenericViewMixin
  ]
}
</script>
